import * as types from '../types'
import { TypeMap } from './type-map'

type Primitives = undefined | null | boolean | string | number

export const codeBlockTypes: TypeMap<Exclude<
  types.CodeBlockTypes,
  Primitives
>> = {
  CodeBlock: 'CodeBlock',
  CodeChunk: 'CodeChunk'
}

export const codeFragmentTypes: TypeMap<Exclude<
  types.CodeFragmentTypes,
  Primitives
>> = {
  CodeFragment: 'CodeFragment',
  CodeExpression: 'CodeExpression'
}

export const codeTypes: TypeMap<Exclude<types.CodeTypes, Primitives>> = {
  Code: 'Code',
  CodeBlock: 'CodeBlock',
  CodeChunk: 'CodeChunk',
  CodeExpression: 'CodeExpression',
  CodeFragment: 'CodeFragment'
}

export const creativeWorkTypes: TypeMap<Exclude<
  types.CreativeWorkTypes,
  Primitives
>> = {
  CreativeWork: 'CreativeWork',
  Article: 'Article',
  AudioObject: 'AudioObject',
  Collection: 'Collection',
  Datatable: 'Datatable',
  Figure: 'Figure',
  ImageObject: 'ImageObject',
  MediaObject: 'MediaObject',
  Periodical: 'Periodical',
  PublicationIssue: 'PublicationIssue',
  PublicationVolume: 'PublicationVolume',
  SoftwareApplication: 'SoftwareApplication',
  SoftwareSourceCode: 'SoftwareSourceCode',
  Table: 'Table',
  VideoObject: 'VideoObject'
}

export const entityTypes: TypeMap<Exclude<types.EntityTypes, Primitives>> = {
  Entity: 'Entity',
  ArrayValidator: 'ArrayValidator',
  Article: 'Article',
  AudioObject: 'AudioObject',
  BooleanValidator: 'BooleanValidator',
  Brand: 'Brand',
  Cite: 'Cite',
  CiteGroup: 'CiteGroup',
  Code: 'Code',
  CodeBlock: 'CodeBlock',
  CodeChunk: 'CodeChunk',
  CodeError: 'CodeError',
  CodeExpression: 'CodeExpression',
  CodeFragment: 'CodeFragment',
  Collection: 'Collection',
  ConstantValidator: 'ConstantValidator',
  ContactPoint: 'ContactPoint',
  CreativeWork: 'CreativeWork',
  Datatable: 'Datatable',
  DatatableColumn: 'DatatableColumn',
  Date: 'Date',
  Delete: 'Delete',
  Emphasis: 'Emphasis',
  EnumValidator: 'EnumValidator',
  Figure: 'Figure',
  Function: 'Function',
  Grant: 'Grant',
  Heading: 'Heading',
  ImageObject: 'ImageObject',
  Include: 'Include',
  IntegerValidator: 'IntegerValidator',
  Link: 'Link',
  List: 'List',
  ListItem: 'ListItem',
  Mark: 'Mark',
  Math: 'Math',
  MathBlock: 'MathBlock',
  MathFragment: 'MathFragment',
  MediaObject: 'MediaObject',
  MonetaryGrant: 'MonetaryGrant',
  NumberValidator: 'NumberValidator',
  Organization: 'Organization',
  Paragraph: 'Paragraph',
  Parameter: 'Parameter',
  Periodical: 'Periodical',
  Person: 'Person',
  Product: 'Product',
  PropertyValue: 'PropertyValue',
  PublicationIssue: 'PublicationIssue',
  PublicationVolume: 'PublicationVolume',
  Quote: 'Quote',
  QuoteBlock: 'QuoteBlock',
  SoftwareApplication: 'SoftwareApplication',
  SoftwareEnvironment: 'SoftwareEnvironment',
  SoftwareSession: 'SoftwareSession',
  SoftwareSourceCode: 'SoftwareSourceCode',
  StringValidator: 'StringValidator',
  Strong: 'Strong',
  Subscript: 'Subscript',
  Superscript: 'Superscript',
  Table: 'Table',
  TableCell: 'TableCell',
  TableRow: 'TableRow',
  ThematicBreak: 'ThematicBreak',
  Thing: 'Thing',
  TupleValidator: 'TupleValidator',
  Variable: 'Variable',
  VideoObject: 'VideoObject',
  VolumeMount: 'VolumeMount'
}

export const grantTypes: TypeMap<Exclude<types.GrantTypes, Primitives>> = {
  Grant: 'Grant',
  MonetaryGrant: 'MonetaryGrant'
}

export const markTypes: TypeMap<Exclude<types.MarkTypes, Primitives>> = {
  Mark: 'Mark',
  Delete: 'Delete',
  Emphasis: 'Emphasis',
  Quote: 'Quote',
  Strong: 'Strong',
  Subscript: 'Subscript',
  Superscript: 'Superscript'
}

export const mathTypes: TypeMap<Exclude<types.MathTypes, Primitives>> = {
  Math: 'Math',
  MathBlock: 'MathBlock',
  MathFragment: 'MathFragment'
}

export const mediaObjectTypes: TypeMap<Exclude<
  types.MediaObjectTypes,
  Primitives
>> = {
  MediaObject: 'MediaObject',
  AudioObject: 'AudioObject',
  ImageObject: 'ImageObject',
  VideoObject: 'VideoObject'
}

export const numberValidatorTypes: TypeMap<Exclude<
  types.NumberValidatorTypes,
  Primitives
>> = {
  NumberValidator: 'NumberValidator',
  IntegerValidator: 'IntegerValidator'
}

export const thingTypes: TypeMap<Exclude<types.ThingTypes, Primitives>> = {
  Thing: 'Thing',
  Article: 'Article',
  AudioObject: 'AudioObject',
  Brand: 'Brand',
  Collection: 'Collection',
  ContactPoint: 'ContactPoint',
  CreativeWork: 'CreativeWork',
  Datatable: 'Datatable',
  DatatableColumn: 'DatatableColumn',
  Figure: 'Figure',
  Grant: 'Grant',
  ImageObject: 'ImageObject',
  MediaObject: 'MediaObject',
  MonetaryGrant: 'MonetaryGrant',
  Organization: 'Organization',
  Periodical: 'Periodical',
  Person: 'Person',
  Product: 'Product',
  PropertyValue: 'PropertyValue',
  PublicationIssue: 'PublicationIssue',
  PublicationVolume: 'PublicationVolume',
  SoftwareApplication: 'SoftwareApplication',
  SoftwareEnvironment: 'SoftwareEnvironment',
  SoftwareSession: 'SoftwareSession',
  SoftwareSourceCode: 'SoftwareSourceCode',
  Table: 'Table',
  VideoObject: 'VideoObject',
  VolumeMount: 'VolumeMount'
}

export const validatorTypes: TypeMap<Exclude<
  types.ValidatorTypes,
  Primitives
>> = {
  ConstantValidator: 'ConstantValidator',
  EnumValidator: 'EnumValidator',
  BooleanValidator: 'BooleanValidator',
  NumberValidator: 'NumberValidator',
  IntegerValidator: 'IntegerValidator',
  StringValidator: 'StringValidator',
  ArrayValidator: 'ArrayValidator',
  TupleValidator: 'TupleValidator'
}

export const variableTypes: TypeMap<Exclude<
  types.VariableTypes,
  Primitives
>> = {
  Variable: 'Variable',
  Parameter: 'Parameter'
}

export const blockContentTypes: TypeMap<Exclude<
  types.BlockContent,
  Primitives
>> = {
  CodeBlock: 'CodeBlock',
  CodeChunk: 'CodeChunk',
  Heading: 'Heading',
  List: 'List',
  ListItem: 'ListItem',
  MathBlock: 'MathBlock',
  Paragraph: 'Paragraph',
  QuoteBlock: 'QuoteBlock',
  Table: 'Table',
  ThematicBreak: 'ThematicBreak'
}

export const inlineContentTypes: TypeMap<Exclude<
  types.InlineContent,
  Primitives
>> = {
  CodeFragment: 'CodeFragment',
  CodeExpression: 'CodeExpression',
  Delete: 'Delete',
  Emphasis: 'Emphasis',
  ImageObject: 'ImageObject',
  Link: 'Link',
  MathFragment: 'MathFragment',
  Quote: 'Quote',
  Strong: 'Strong',
  Subscript: 'Subscript',
  Superscript: 'Superscript',
  Cite: 'Cite',
  CiteGroup: 'CiteGroup'
}
